<template>
  <div class="select-course-assistant-start">
    <ym-img class="select-course-assistant-start-bg"
            :src="require('@/assets/img/select_course_assistant/start_bg.png')"
    />
    <div class="select-course-assistant-start-btn"
         @click="handleClickBtn"
    >
      开始选课
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SelectCourseAssistantStartPage',
    methods: {
      handleClickBtn() {
        this.$emit('show-grade-list');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .select-course-assistant-start {
    padding-top: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-bg {
      width: 500px;
      height: 742px;
      margin-bottom: 100px;
    }
    &-btn {
      width: 424px;
      height: 88px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-primary;
      font-size: 34px;
      font-weight: @font-weight-bold;
      background: @color-white;
      border-radius: 44px;
    }
  }

</style>
